// extracted by mini-css-extract-plugin
module.exports = {"WideRow":"FillInBlanks_WideRow__1CDjk"};